import { ITEM_DEFINITIONS, type GenericItemDefinition } from "../equipment.js";
import { TECHNIQUES } from "./index.js";

export interface TechniqueScrollDefinition extends GenericItemDefinition {
  category: "consumable";
  usage: { kind: "technique_scroll"; techniqueId: string };
  stacking: GenericItemDefinition["stacking"] & { enabled: true };
}

const scrolls = ITEM_DEFINITIONS.filter(
  (item): item is TechniqueScrollDefinition =>
    item.category === "consumable" && item.usage?.kind === "technique_scroll",
);

const byTechniqueId = new Map<string, TechniqueScrollDefinition>();
for (const scroll of scrolls) {
  const techniqueId = scroll.usage.techniqueId;
  if (!TECHNIQUES[techniqueId])
    throw new Error(
      `Technique scroll ${scroll.id} references unknown technique ${techniqueId}.`,
    );
  if (scroll.id !== `technique_scroll_${techniqueId}`)
    throw new Error(
      `Technique scroll ${scroll.id} must use the stable ID technique_scroll_${techniqueId}.`,
    );
  if (byTechniqueId.has(techniqueId))
    throw new Error(`Technique ${techniqueId} has more than one scroll item.`);
  byTechniqueId.set(techniqueId, scroll);
}

for (const techniqueId of Object.keys(TECHNIQUES)) {
  if (!byTechniqueId.has(techniqueId))
    throw new Error(
      `Technique ${techniqueId} is missing its exclusive scroll item.`,
    );
}

export const TECHNIQUE_SCROLLS: Readonly<
  Record<string, TechniqueScrollDefinition>
> = Object.freeze(Object.fromEntries(byTechniqueId));

export function techniqueScrollDefinition(
  techniqueId: string,
): TechniqueScrollDefinition | undefined {
  return TECHNIQUE_SCROLLS[techniqueId];
}
